module.exports = __webpack_public_path__ + "img/product_all.be30de94.jpg";